import { z } from 'zod';

const authSchema = z.object({
  Auth: z.object({
    Cognito: z.object({
      userPoolId: z.string(),
      userPoolClientId: z.string(),
      loginWith: z.object({
        oauth: z.object({
          domain: z.string(),
          scopes: z.array(z.string()),
          redirectSignIn: z.array(z.url()),
          redirectSignOut: z.array(z.url()),
          responseType: z.string(),
        }),
      }),
    }),
  }),
});

const envSchema = z.object({
  VITE_ROOT_API_URL: z.url(),
  VITE_AUTH_COOKIE_NAME: z.string(),
  VITE_AUTH_COOKIE_EXPIRES_MS: z.coerce.number(),
  VITE_AUTH_DEVELOPER1_ID: z.string(),
  VITE_AUTH_CONFIG: authSchema,
  VITE_SAGE_MAKER_URL: z.url().or(z.literal('')),
});

export type Env = z.infer<typeof envSchema>;
export const ENV: Env = envSchema.parse(import.meta.env);
